export default __webpack_public_path__ + "static/1-f1b1b6bce6b4b58e0be747d1c21dd9a6.svg";